import { z } from 'zod';
export const WsMessageType = z.enum([
    // Interceptor -> Server
    'ACTION_EVENT',
    'SNAPSHOT_CREATED',
    'PROTECTION_VIOLATION',
    'INTERCEPTOR_HEARTBEAT',
    'INTERCEPTOR_STATUS',
    // Server -> Interceptor
    'COMMAND_STOP',
    'COMMAND_CONTINUE',
    'ZONE_UPDATE',
    'CONFIG_UPDATE',
    'ACK',
    // Server -> Dashboard
    'EVENT_BROADCAST',
    'STATE_CHANGE',
    'RISK_ALERT',
    'STATS_UPDATE',
    'ZONE_BROADCAST',
    // Dashboard -> Server
    'COMMAND_RESET',
    'COMMAND_ROLLBACK',
    'SUBSCRIBE',
    'UNSUBSCRIBE',
    // UI Simulator <-> Server
    'SIMULATOR_PATCH',
    'SIMULATOR_RESYNC',
    'SIMULATOR_SNAPSHOT',
    'SIMULATOR_CONFLICT',
    // Server -> Dashboard (Agent)
    'AGENT_STATUS_CHANGE',
    'AGENT_LOCATION_UPDATE',
    'AGENT_PLAN_UPDATE',
    'AGENT_BREADCRUMB',
    'AGENT_OUTPUT',
    'AGENT_TOKEN_USAGE',
    'AGENT_ERROR',
    'AGENT_PHASE_UPDATE',
    'AGENT_BREAKPOINT_HIT',
    'AGENT_BREAKPOINT_SET',
    'AGENT_BREAKPOINT_REMOVED',
    'AGENT_INJECTION_QUEUED',
    'AGENT_INJECTION_APPLIED',
    'AGENT_REDIRECTED',
    'AGENT_CHECKPOINT_SAVED',
    // Dashboard -> Server (Agent)
    'AGENT_SPAWN',
    'AGENT_STOP',
    'AGENT_RESUME',
    'AGENT_KILL',
    'AGENT_INJECT_PROMPT',
    'AGENT_PHASE_APPROVE',
    'AGENT_PHASE_REJECT',
    // Simulator -> Server (Agent Constraints)
    'SIMULATOR_CONSTRAINT',
    'SIMULATOR_REFERENCE_IMAGE',
    // Simulator -> Server (Design Snapshot)
    'SIMULATOR_DESIGN_SNAPSHOT',
    // Dev Server
    'DEV_SERVER_STATUS',
]);
export const WsMessage = z.object({
    type: WsMessageType,
    payload: z.unknown(),
    correlationId: z.string().uuid().optional(),
    sequenceNumber: z.number().int().optional(),
    timestamp: z.number(),
    clientId: z.string().uuid().optional(),
});
export const ClientType = z.enum(['interceptor', 'dashboard', 'simulator']);
export const ClientRegistration = z.object({
    type: z.literal('REGISTER'),
    clientType: ClientType,
    clientId: z.string().uuid(),
    projectId: z.string().uuid(),
    authToken: z.string().optional(),
    lastSequenceNumber: z.number().int().optional(),
});
//# sourceMappingURL=ws-protocol.js.map